import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
import { ViewType } from '../../../grid/gridView/types';
import { getColumnDetails, COLUMNS, FILTERS } from '../types';

export class XdrSearchResultsPanelBaseDataProvider extends BaseWebComponentDataProvider {
  async getDataForView(): Promise<any> {
    const view = {
      id: '12345',
      name: 'Default view',
      type: ViewType.DEFAULT,
      filters: FILTERS,
      displayedColumns: COLUMNS,
      pageSize: 50,
      selectedTargets: [
        {
          companyId: 'vagrant',
          companyName: 'Vagrant',
        },
      ],
      compactView: false,
    };
    return {
      targets: [
        {
          companyId: 'vagrant',
          companyName: 'Vagrant',
        },
      ],
      isPartner: false,
      views: [view],
      allColumns: getColumnDetails(this.dependencies.translateFn),
      defaultViewProps: view,
    };
  }
}
